import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "resolve-filled-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { fill: "currentColor", d: "M8.5 1a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15Zm3.344 4.57a.55.55 0 0 0-.773.086l-3.617 4.52L5.89 8.612a.55.55 0 0 0-.778.778l2 2a.55.55 0 0 0 .818-.045l4-5a.55.55 0 0 0-.085-.773Z" }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
